export const isPresent = (string) => {
  return typeof string === "string" && string.trim() !== "";
};

export const blankOrValue = (val) => {
  return val == undefined ? "" : val;
};
